var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{attrs:{"transition":"slide-y-reverse-transition","indeterminate":"","color":"primary","size":"50"}})}
var staticRenderFns = []

export { render, staticRenderFns }